import React, { Ref, forwardRef, InputHTMLAttributes } from 'react';
import { classNames } from 'primereact/utils';
import { normalizeInputValue } from 'utils/text';
import { getInputBaseClassName } from '../InputBase';

export type InputTextProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'value'> & {
	variant?: 'white';
	inline?: boolean;
	search?: boolean;
	value?: string | number | null;
	invalid?: boolean;
	minimal?: boolean;
	slim?: boolean;
};

export const InputText = forwardRef(
	(
		{
			variant,
			className,
			inline,
			search = false,
			value,
			invalid = false,
			minimal = false,
			slim = false,
			...restProps
		}: InputTextProps,
		ref: Ref<HTMLInputElement>
	) => {
		return (
			<input
				ref={ref}
				type={search ? 'search' : 'text'}
				className={classNames(
					getInputBaseClassName({ inline, slim, minimal, invalid }),
					'input-text',
					{ 'input-color': restProps.type === 'color' },
					className
				)}
				value={normalizeInputValue(value)}
				{...restProps}
			/>
		);
	}
);
